export default class BottomSheet extends HTMLElement {
  constructor() {
    super();

    this.$close = this.querySelectorAll("[data-toggle='bottom-sheet-close']");
    this.$buttons = document.querySelectorAll(
      `[data-toggle="bottom-sheet"][data-target="${this.id}"]`
    );

    this.$listItems = document.querySelectorAll(".bottom-sheet__list__button");
  }

  connectedCallback() {
    this.$buttons.forEach((button) => {
      button.addEventListener("click", () => this.open());
    });
    this.$close.forEach((button) =>
      button.addEventListener("click", () => this.close())
    );
    this.$listItems.forEach((listItem) => {
      listItem.addEventListener("click", (event) =>
        this.handleClickListItem(event)
      );
    });
  }

  disconnectedCallback() {
    this.$buttons.forEach((button) => {
      button.removeEventListener("click", () => this.open());
    });
    this.$close.forEach((button) =>
      button.removeEventListener("click", () => this.close())
    );
  }

  open() {
    this.classList.add("bottom-sheet--active");
  }

  close() {
    this.classList.remove("bottom-sheet--active");
  }

  handleClickListItem({ target }) {
    this.$listItems.forEach((listItem) => {
      listItem.classList.remove("bottom-sheet__list__button--active");
    });
    target.classList.add("bottom-sheet__list__button--active");
  }
}
